import PrivacyPolicyPageComponent from './component'

const PrivacyPolicyPage: React.FC = (): React.ReactElement => {
	return <PrivacyPolicyPageComponent />
}
export default PrivacyPolicyPage
